module.exports = __webpack_public_path__ + "img/img17.81689165.png";